import styled from 'styled-components';
import { Common, device, color } from '@stockbit/ui';

const { Flex, Text } = Common;

const HeaderWrapper = styled(Flex).attrs({
  m: 'auto',
  as: 'header',
  direction: 'column',
})`
  margin-top: 50px;
  padding: 0 25px;
  padding-top: 100px;
  width: 100%;
  max-width: 1300px;

  @media ${device.tablet} {
    padding: 0;
    padding-top: 120px;
    width: calc(100% - 151px);
  }

  @media ${device.laptop} {
    margin-top: 0px;
  }
`;

const Wrapper = styled(Flex).attrs({
  m: 'auto',
  as: 'section',
})`
  flex-direction: column;
  padding: 50px 25px;
  width: 100%;
  max-width: 1300px;

  @media ${device.tablet} {
    padding: 50px 30px;
  }

  @media ${device.laptop} {
    padding: 50px 0;
    width: calc(100% - 150px);
  }
`;

const HeaderTitle = styled(Text).attrs({
  color: color.primary,
  size: '60px',
  height: 1.3,
  family: 'bold',
  as: 'h1',
})`
  text-align: center;
  margin: auto;
  margin-bottom: 20px;
`;

const HeaderDescription = styled(Text).attrs({
  size: '19px',
  m: '0 auto',
  height: 1,
})`
  text-align: center;
  font-weight: normal;
`;

export { HeaderWrapper, Wrapper, HeaderTitle, HeaderDescription };
